import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  title = 'Chat - Tasa de Seguridad y Convivencia de Antioquia';

  constructor(
    private titleService: Title,
    private router: Router
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.title);

    // Redireccionar al chat después de 5 segundos
    setTimeout(() => {
      this.router.navigate(['/chat-tasa']);
    }, 5000);
  }
}